import { render, staticRenderFns } from "./CustomizeBrandTheme.vue?vue&type=template&id=258bc9a4&scoped=true&"
import script from "./CustomizeBrandTheme.vue?vue&type=script&lang=js&"
export * from "./CustomizeBrandTheme.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeBrandTheme.vue?vue&type=style&index=0&id=258bc9a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258bc9a4",
  null
  
)

export default component.exports